var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('Navbar'),_c('router-view'),_c('Footer',{staticClass:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }